<ion-button color="clear" (click)="openPicker()">
  <span style="color: black">{{ formControl.value }}</span>
  <ion-icon color="primary" slot="end" name="alarm-outline"></ion-icon>
</ion-button>
